import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import { useMutation } from "react-relay"
import { graphql } from "relay-runtime"
import { toast } from "@/hooks/useToast"
import {
  ShareMedicalRecordInput,
  useShareMedicalRecordMutation as useShareMedicalRecordMutationType,
} from "@/modules/patients/services/__generated__/useShareMedicalRecordMutation.graphql"

const shareMedicalRecordMutation = graphql`
  mutation useShareMedicalRecordMutation($input: ShareMedicalRecordInput!) {
    shareMedicalRecord(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useShareMedicalRecord = () => {
  const { t } = useTranslation()
  const [commit] = useMutation<useShareMedicalRecordMutationType>(shareMedicalRecordMutation)

  return useCallback(
    (input: ShareMedicalRecordInput, agentFullName: string) => {
      commit({
        variables: {
          input,
        },
        onCompleted() {
          toast({
            description: t("patient.shareMedicalRecord.sharedSucceeded", {
              agent: agentFullName,
            }),
            isClosable: true,
          })
        },
        onError() {
          toast({
            description: t("patient.shareMedicalRecord.sharedFailed"),
            isClosable: true,
          })
        },
      })
    },
    [commit, t],
  )
}
